import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  contentContainer: {
    flexDirection: 'row',
    gap: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
